import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// const baseUrl = process.env.REACT_BACKEND_ENDPOINT;
const baseUrl = "https://api.vampay.in/Merchent";

export const myApi = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set("Origin", "https://vaamoz.com");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getMerchantDetails: builder.mutation({
      query: (id: string | undefined) => ({
        url: "/CommonInvoiceTransaction",
        method: "PUT",
        body: { merchnat_id: id },
      }),
    }),
    initiateTransaction: builder.mutation({
      query: ({
        amount,
        merchnat_id,
      }: {
        amount: string;
        merchnat_id: string;
      }) => ({
        url: "/CommonInvoiceTransaction",
        method: "POST",
        body: { amount: amount, merchnat_id: merchnat_id },
      }),
    }),
    checkTransactionStatus: builder.mutation({
      query: (invoice_id: string | undefined) => ({
        url: "/InvoiceTransactionWebhook",
        method: "PUT",
        body: { invoice_id },
      }),
    }),
    validateUpi: builder.mutation({
      query: (upi_id: string) => ({
        url: "/ValidateVpaId",
        method: "PUT",
        body: { vpa_id: upi_id },
      }),
    }),
  }),
});

export const {
  useGetMerchantDetailsMutation,
  useInitiateTransactionMutation,
  useCheckTransactionStatusMutation,
  useValidateUpiMutation,
} = myApi;
